module.exports = __webpack_public_path__ + "static/icon-instagram-5ada4914b35e8c2862cbd1d9a4ae3b77.svg";